import React from 'react';
import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';

import {
    INTERVENTION_ACCESS_ROLES, NOT_DISTRIBUTOR_ROLES, ROUTES, STOCK_ROLES_WITH_INTERVENTION_MANAGER
} from 'utils/constants';
import { UserHelper } from 'utils/helpers';

import {
    PageAdministration,
    PageCookies,
    PageHome,
    PageInterventionDetail,
    PageInterventionInspection,
    PageInterventionList,
    PageInterventionPlanification,
    PageRGPD,
    PageStocks,
    PageUserDetail
} from 'pages';

import { BottleDetail, EquipmentList } from 'components';
import { useStores } from 'hooks';

const InterventionAccessRoute = ({ children }) => {
    const hasAccessRights = UserHelper.hasAccessRight(INTERVENTION_ACCESS_ROLES);

    if (!hasAccessRights) {
        return <Navigate replace to={ROUTES.HOME} />;
    }
    return children;
};

const AdministrativeRoute = ({ component: Component }) => {
    const hasAccessRights = UserHelper.hasAccessRight(STOCK_ROLES_WITH_INTERVENTION_MANAGER);

    if (!hasAccessRights) {
        return <Navigate replace to={ROUTES.HOME} />;
    }

    return <Component />;
};

const RouteHome = ({ component: Component }) => {
    const { userStore } = useStores();

    if (!(UserHelper.hasAccessRight(NOT_DISTRIBUTOR_ROLES) || userStore.isViewingInstitution())) {
        return <Navigate replace to={ROUTES.STOCKS} />;
    }

    return <Component />;
};

export const Routes = () => (
  <RouterRoutes>
    <Route element={<RouteHome component={PageHome} />} path={ROUTES.HOME} />
    <Route element={<BottleDetail />} path={ROUTES.CONTAINERS.DETAIL} />

    <Route element={
      <InterventionAccessRoute>
        <PageInterventionList />
      </InterventionAccessRoute>
        } path={ROUTES.INTERVENTION.LIST} />

    <Route element={
      <InterventionAccessRoute>
        <PageInterventionDetail />
      </InterventionAccessRoute>
        } path={ROUTES.INTERVENTION.DETAIL} />

    <Route element={
      <InterventionAccessRoute>
        <PageInterventionPlanification />
      </InterventionAccessRoute>
        } path={ROUTES.INTERVENTION.PLAN} />

    <Route element={
      <InterventionAccessRoute>
        <PageInterventionInspection />
      </InterventionAccessRoute>
        } path={ROUTES.INTERVENTION.FORM} />

    <Route element={<PageUserDetail />} path={ROUTES.USERS.DETAIL} />
    <Route element={<EquipmentList />} path={ROUTES.EQUIPEMENT_OWNER} />

    <Route element={<PageStocks />} path={ROUTES.STOCKS} />
    <Route element={<PageStocks />} path={ROUTES.STOCKS_INITIALISATION} />
    <Route element={<PageStocks />} path={ROUTES.STOCKS_PENDING} />
    <Route element={<PageStocks />} path={ROUTES.STOCKS_FLUIDS} />
    <Route element={<PageStocks />} path={ROUTES.STOCKS_CONTAINERS} />
    <Route element={<PageStocks />} path={ROUTES.STOCKS_VALIDATION} />
    <Route element={<PageStocks />} path={ROUTES.STOCKS_BALANCE} />

    <Route element={<PageRGPD />} path={ROUTES.RGPD} />
    <Route element={<PageCookies />} path={ROUTES.COOKIES} />

    <Route element={<AdministrativeRoute component={PageAdministration} />} path={ROUTES.ADMINISTRATION_TOOLS} />
    <Route element={<AdministrativeRoute component={PageAdministration} />} path={ROUTES.ADMINISTRATION_SUPPLIERS_RECIPIENTS} />
    <Route element={<AdministrativeRoute component={PageAdministration} />} path={ROUTES.ADMINISTRATION_USERS} />
    <Route element={<AdministrativeRoute component={PageAdministration} />} path={ROUTES.ADMINISTRATION_INSTITUTIONS} />
    <Route element={<AdministrativeRoute component={PageAdministration} />} path={ROUTES.ADMINISTRATION_TRACK_DECHETS} />
    <Route element={<AdministrativeRoute component={PageAdministration} />} path={ROUTES.ADMINISTRATION} />

    <Route element={<Navigate replace to={ROUTES.HOME} />} path="*" />
  </RouterRoutes>
);
